import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'NiotaClassicGwMgmtCharts',
  props: {
    packetsBar: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    rssiGraph: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    lsnrGraph: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    sfGraph: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    loadingMetrics: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {// selectedTimeFrame: { value: '24h', interval: 'hour', name: this.$i18n_t('NiotaClassic.Devices.details.last24') },
      // timeFrames: [
      //   { value: '24h', interval: 'hour', name: this.$i18n_t('NiotaClassic.Devices.details.last24') },
      //   { value: '1w', interval: 'day', name: this.$i18n_t('NiotaClassic.Devices.details.lastWeek') },
      //   { value: '1M', interval: 'day', name: this.$i18n_t('NiotaClassic.Devices.details.lastMonth') },
      // ],
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']))
};